<template>
  <button class="mr-3 btn white big"
          type="button"
          :disabled="campaignPartialSaveLoading"
          @click="saveFormData">Save
  </button>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'CampaignSaveButton',
  props: {
    campaignPartial: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('campaign', [
      'campaignPartialSaveLoading',
      'campaignPartialSaveCompleted',
      'campaignPartialSaveError',
      'campaignActionErrorMessage',
    ]),
  },
  methods: {
    ...mapActions('campaign', ['partialSaveCampaign']),
    saveFormData() {
      this.partialSaveCampaign(this.campaignPartial).then(() => {
        if (this.campaignPartialSaveCompleted) {
          this.$message({
            type: 'success',
            message: 'Campaign has been successfully updated!.',
          })

          this.$emit('save-success')
        } else if (this.campaignPartialSaveError) {
          this.$message({
            type: 'error',
            message: this.campaignActionErrorMessage,
          })
        }
      })
    },
  },
}
</script>